exports.en = {
  CZK: 'Kč',
  FUND_ACTUAL: {
    LABEL: 'Aktuální hodnota',
    DATE: 'Údaje ke dni',
    UNIT_VALUE: 'Hodnota jednotky fondu',
    FUNDS_CAPITAL_VALUE: 'Hodnota fondového vlastního kapitálu',
    UNITS_COUNT: 'Celkový počet jednotek fondu'
  }
}
